'product': {
  'productContainer': {
    'invalidInviteCode': 'El código de invitación no existe o ha expirado'
  }
}<template>
  <div v-if="isMaxScreen">
    <Head></Head>
    <div class="pc_select-model">
      <div style="flex: 1; overflow-y: auto; height: 100%">
        <PC-order-step></PC-order-step>
        <PC-bread-nav :not-invite="notInvite" :show-back="!notInvite"></PC-bread-nav>
        <div class="model-main">
          <div class="model-item">
            <PC-category-tab :categoryList="categoryList" @onChange="changeCategory" />
            <PC-brand-tab :brandList="brandList" @onChange="changeBrand" />
            <PC-model-list :productList="phoneList" :not-invite="notInvite" />
            <div class="pagination-div">
              <el-pagination
                background
                :current-page.sync="currentPage"
                :page-size="pageSize"
                layout="prev, pager, next, jumper"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="product">
    <h-head></h-head>
    <!-- 搜索框 -->
    <div class="search">
      <div class="input" @click="toPage">
        <img src="../../assets/image/product/search.png" alt="" />
        <span>{{ $t('PCSearch.index.646wgb1ni8k0') }}</span>
      </div>
    </div>
    <!-- 分类 -->
    <!--分类-->
    <category-tab :data="categoryList" @onChange="changeCategory"></category-tab>
    <!--品牌列表-->
    <brand-list
      ref="brandList"
      :data="brandList"
      :active="activeBrandId"
      :hasTab="hasTab"
      @onchange="changeBrand"
    ></brand-list>
    <!-- 机型列表 -->
    <phone-model-list
      ref="phoneModelList"
      :data="phoneList"
      :finished="finished"
      :phoneLoading="phoneLoading"
      :hasTab="hasTab"
      @onLoad="onLoad"
    ></phone-model-list>
  </div>
</template>

<script>
import { List, PullRefresh } from 'vant';
import { mapState } from 'vuex';

import hHead from '@/components/layout/head.vue';
// import PCHeadNav from '@/components/PCHeadNav'
import PCBreadNav from '@/components/PCBreadNav';
import PCOrderStep from '@/components/PCOrderStep';
import PCScroll from '@/components/PCScroll';
import { getChannelId, getNationCode } from '@/utils/channel';

import Head from '../../components/head';
import {
  checkQrCode,
  getBrandList,
  getCategoryList,
  phoneModelList} from '../../services/api/product';
import BrandList from './components/brand-list';
import CategoryTab from './components/category-tab.vue';
import PCBrandTab from './components/PCBrandTab';
import PCCategoryTab from './components/PCCategoryTab';
import PCModelList from './components/PCModelList';
import PhoneModelList from './components/phone-model-list.vue';
export default {
  name: 'Product',
  components: {
    CategoryTab,
    BrandList,
    // "van-list": List,
    // "van-pull-refresh": PullRefresh,
    PhoneModelList,
    Head,
    PCScroll,
    // PCHeadNav,
    PCBreadNav,
    PCOrderStep,
    PCCategoryTab,
    PCBrandTab,
    PCModelList,
    hHead
  },
  data() {
    return {
      categoryList: [],
      brandList: [],
      phoneList: [],
      activeBrandId: 1,
      finished: false,
      phoneLoading: true,
      notInvite: true,
      categoryList: [],
      categoryId: '',
      activeBrandId: 1,
      pageSize: 15,
      currentPage: 1,
      total: 0,
      isShowCard: false
      // pageSize: 30,
      // currentPage: 1,
    };
  },
  computed: {
    // 判断是否是PC端
    ...mapState({
      isMaxScreen: state => state.isMaxScreen
    }),
    /**
     * 是否含有tab，有tab的话样式需要做兼容
     */
    hasTab() {
      return this.categoryList.length >= 1;
    }
  },
  created() {
    this.init();
    this.qrcodeVerify();

    console.log(this.$route.query.productName);
    if (this.$route.query.productName) {
      const productName = this.$route.query.productName;
      sessionStorage.setItem('productName', productName);
    }
  },
  methods: {
    qrcodeVerify() {
      if (this.$route.query.qrCode) {
        checkQrCode({
          qrCode: this.$route.query.qrCode
        })
          .then(res => {
            if (res.code == '0000') {
              if (!res.data) {
                this.$message.error(this.$t('product.productContainer.invalidInviteCode'));
              }
            }
          })
          .catch(err => {
            console.log(108, err);
          });
      }
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPhoneList();
    },
    /**
     * 初始化
     */
    async init() {
      // let channel = this.$route.query.channel;
      // let mobile = this.$route.query.mobile;
      // Cookie.set("channel", 125020);
      // Cookie.set("mobileFromYiDong", mobile);

      await this.getCategoryList()
        .then(() => {
          this.getBrandList();
        })
        .catch(err => {
          console.log(108, err);
        });

      // 延迟隐藏，让loading更丝滑
      setTimeout(() => {
        this.loading = false;
      }, 300);
    },
    /**
     * 获取分类列表
     */
    getCategoryList() {
      return new Promise((resolve, reject) => {
        getCategoryList()
          .then(res => {
            const { code, data } = res;
            if (code === '0000') {
              // let categoryList = data || [];
              const categoryList = [
                {
                  categoryId: 2,
                  categoryName: this.$t('product.category.mobiles')
                }
              ];
              this.categoryList = categoryList.filter(o => true);
              if (this.categoryList.length > 0) {
                this.categoryId = this.categoryList[0].categoryId;
              }
              console.log(categoryList);
              resolve(res);
            } else {
              reject(res);
            }
          })
          .catch(res => {
            reject(res);
          });
      });
    },
    /**
     * 获取品牌列表
     */
    getBrandList() {
      const channelId = getChannelId();
      const nation = getNationCode();

      getBrandList({ categoryId: this.categoryId, channelId: channelId, nation: nation }).then(res => {
        const { code, data } = res;
        if (code === '0000') {
          console.log('brandList', data);
          this.brandList = this.brandSort(data);
          sessionStorage.setItem('brandList', JSON.stringify(this.brandList));
          if (this.brandList.length > 0) {
            this.changeBrand(this.brandList[0].brandId);
          }
        }
      });
    },

    brandSort(brands) {
      console.log(brands);
      // 找出 brandId 为 11 和 1 的索引
      const brand11Index = brands.findIndex(item => item.brandId === 11);
      const brand1Index = brands.findIndex(item => item.brandId === 1);

      // 创建新数组
      const result = [...brands];

      // 如果找到了 brandId 为 11 的品牌，则移到第一位
      if (brand11Index !== -1) {
        const [brand11] = result.splice(brand11Index, 1);
        result.unshift(brand11);
      }

      // 如果找到了 brandId 为 1 的品牌，则移到第二位（但要考虑 brandId 为 11 的品牌已经在第一位的情况）
      if (brand1Index !== -1) {
        const currentBrand1Index = result.findIndex(item => item.brandId === 1);
        if (currentBrand1Index !== -1 && currentBrand1Index !== 1) {
          const [brand1] = result.splice(currentBrand1Index, 1);
          result.splice(1, 0, brand1);
        }
      }

      return result;
    },
    /**
     * 获取机型列表
     */
    getPhoneList() {
      const channelId = getChannelId();
      const nation = getNationCode();

      const data = {
        brandId: this.activeBrandId,
        categoryId: this.categoryId,
        channelId: channelId,
        nation: nation,
        pageIndex: this.currentPage,
        pageSize: this.pageSize
      };

      phoneModelList(data).then(res => {
        this.phoneLoading = false;
        const { code, data } = res;
        if (code === '0000') {
          this.isMaxScreen ? '' : this.$refs.phoneModelList.hideLoading();
          if (this.isMaxScreen) {
            this.phoneList = data.list;
          } else {
            this.phoneList = this.phoneList.concat(data.list);
          }

          this.total = res.data.total;
          if (!(this.phoneList.length < res.data.total)) {
            this.finished = true;
          }
        }
      });
    },
    /**
     * 选择分类
     */
    changeCategory(i) {
      this.activeBrandId = i;
      this.phoneLoading = true;
      this.tabActive = i;
      this.categoryId = this.categoryList[i].categoryId;
      this.currentPage = 1;
      this.phoneList = [];
      this.getBrandList();
    },
    /**
     * 选择品牌
     * @param id
     */
    changeBrand(id) {
      this.activeBrandId = id;
      this.phoneLoading = true;
      this.finished = false;
      this.currentPage = 1;
      this.isMaxScreen ? '' : this.$refs.phoneModelList.hideLoading();
      this.phoneList = [];
      this.getPhoneList();
    },
    /**
     * 上拉加载
     */
    onLoad() {
      if (!this.finished) {
        this.currentPage++;
        this.getPhoneList();
      }
    },
    /**
     * 跳转页面
     */
    toPage() {
      this.$router.push('/search');
    }
  }
};
</script>
<style scoped lang="less">
@media (max-width: 980px) {
  .product {
    .search {
      position: fixed;
      top: 88px;
      left: 0;
      right: 0;
      z-index: 1;
      padding: 12px 24px;
      box-sizing: border-box;
      background: #fff;
      border-bottom: 1px solid #f7f7f7;
      .input {
        width: 100%;
        height: 64px;
        border-radius: 32px;
        background: #f7f7f7;
        padding: 16px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        img {
          width: 32px;
          height: 32px;
          margin-right: 16px;
        }
        span {
          font-size: 28px;
          color: #ccc;
        }
      }
    }
  }
}
@media (min-width: 981px) {
  .pc_select-model {
    // background-color: #f8f8f8;
    width: 1200px;

    margin: 0 auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 100px;
    .model-main {
      // display: flex;
      justify-content: center;
      .model1-item {
        width: 1200px;
      }
    }
  }
  .sclist {
    width: 100%;
    height: calc(100vh - 45px);
    overflow-y: scroll;
  }
  .pagination-div {
    margin-top: 40px;
    margin-bottom: 80px;
    display: flex;
    justify-content: center;

    /deep/.el-pagination__editor {
      margin: 0 8px;
    }

    /deep/ .el-pager .number {
      background-color: #fff;
    }
    /deep/ .el-pagination.is-background {
      .btn-prev,
      .btn-next {
        background-color: #fff;
      }
    }
    /deep/ .el-pagination.is-background .el-pager li {
      &:hover {
        background-color: #405fff;
        color: #fff;
      }
    }
    /deep/ .el-pagination__editor.el-input .el-input__inner {
      &:focus {
        border-color: #405fff;
      }
    }
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #405fff;
  }
}
</style>
